<template src="./ModalCalendarComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
export default {
  name: 'ModalCalendarComponent',
  components: {
    VueDatePicker,
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    location: {
      type: String,
      required: false,
      default: () => ''
    },
    table: {
      type: String,
      required: false,
      default: () => ''
    },
    listItemSelected: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['dateSelected'],
  setup(props, {emit}) {
    const dataModal = ref({
      file_name: {
        id: 'file_name',
        label: 'Tên file',
        placeholder: 'Tên file',
        value: '',
        required: false,
        disable: false,
      },
      table_use: {
        id: 'table_use',
        label: 'Nơi sử dụng',
        placeholder: 'Nơi sử dụng',
        value: '',
        required: false,
        disable: true,
      },
      name: {
        id: 'name',
        label: 'Tên cài đặt',
        placeholder: 'Tên cài đặt',
        value: '',
        required: false,
        disable: false,
        options: []
      },
      type: {
        id: 'type',
        label: 'Kiểu File',
        placeholder: 'Kiểu File',
        value: '',
        required: false,
        disable: true,
      },
    })
    const date = ref(new Date())
    const labelConfirm = ref('Xác nhận')

    function onChange(value, name) {
      dataModal.value[name].value = value;
    }

    function confirmDate() {
      emit('dateSelected', date.value);
    }

    const handleDate = (modelData) => {
      date.value = modelData
      console.log('modelData', modelData)
    }

    return {
      dataModal,
      labelConfirm,
      onChange,
      confirmDate,
      handleDate,
      date,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modalCalendar {
  .dp__main {
    justify-content: center;
    > div:nth-child(2) {
      width: 90%;
    }
    .dp__cell_disabled {
      opacity: 0.4 !important;
      pointer-events: none;
    }
    .dp__action_button {
      display: none !important;
    }
  }
  .modal-body {
    padding: 1.5rem 0 0 0;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
